import React from 'react';
import { ShieldCheck } from 'lucide-react';

/**
 * Reassures buyers that the final amount is shown before paying —
 * no hidden fees or surprises.
 */
export const SecurePaymentNote = ({
  className = ''
}: {
  className?: string;
}) => <div className={`mx-auto flex max-w-sm items-start justify-center gap-2.5 rounded-xl border border-emerald-500/25 bg-emerald-500/[0.06] px-4 py-3 text-center sm:text-left ${className}`} data-id="element-373" data-mp="1c7o0oralu6p1">
    <ShieldCheck size={18} className="mt-0.5 hidden shrink-0 text-emerald-400 sm:block" aria-hidden="true" data-id="element-374" data-mp="1m6wzpykbubi9" />
    <div data-id="element-375" data-mp="1q777ngrojbzr">
      <p className="flex items-center justify-center gap-1.5 text-xs font-bold uppercase tracking-wide text-emerald-400 sm:justify-start" data-id="element-376" data-mp="1q6xczfvowgnq">
        <ShieldCheck size={14} className="shrink-0 sm:hidden" aria-hidden="true" data-id="element-377" data-mp="1zzcz8pe0rref" />
        Veilig &amp; transparant betalen
      </p>
      <p className="mt-1 text-xs leading-snug text-slate-300" data-id="element-378" data-mp="24zhds9vdac20">
        Je ziet het eindbedrag vóórdat je betaalt. Geen verrassingen, geen
        onverwachte extra kosten.
      </p>
    </div>
  </div>;